import { SettlementOverview } from "../../components/report/settlementOverview";

export default function SettlementOverviewPage() {
  return <SettlementOverview />;
}
